import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { IProductoPortabilidad } from '../pages/portabilidadweb/ProductosPortabilidad';
import { TokenService } from './token.service';
import { environment } from '../../environments/environment';
import { IRequestPortabilidad } from '../pages/portabilidadweb/RequestPortabilidad';

@Injectable({
  providedIn: 'root'
})
export class PortabilidadService {

  constructor(private readonly http: HttpClient, private readonly tokenService: TokenService ) { }

  private getHeaders(sinTokenCliente: boolean = false): HttpHeaders {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': this.tokenService.getToken() ?? ''
    });

    if (!sinTokenCliente) {
      const token = this.tokenService.getTokenCliente();
      if (token) {
        headers = headers.set('Authorization', token);
      }
    }

    return headers;
  }

  public API_URL: string = environment.apiUrl;


    datosSolicitantes(portabilidad: IRequestPortabilidad): Observable<HttpResponse<any>> {
      console.log(portabilidad);
    return this.http.post<any>(this.API_URL + '/datos-solicitante', portabilidad, { headers: this.getHeaders(true), withCredentials: true, observe: "response" });

  }

    solicitudCertificadoLiq(portabilidad: IProductoPortabilidad): Observable<HttpResponse<any>> {
    return this.http.post<any>(this.API_URL + '/solicitud-certificado-liq', portabilidad, { headers: this.getHeaders(true), withCredentials: true, observe: "response" });

  }


}
